/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const ValidationStatus = createEnum('ValidationStatus', {
  SessionWasExpired: 'msg_session_was_expired',
  LoginDenied: 'msg_login_denied',
  LoginDeniedTemporarily: 'msg_login_denied_temporally',
  OfficeIsNotActivated: 'msg_login_office_not_activated',

  CheckStripeAccount: 'msg_stripe_overdue_payment',
  AcceptSubscription: 'msg_stripe_accept_subscription',
  PaymentInProcessStripe: 'msg_stripe_payment_processing',
  OnlyFirstFranchiseCreateSubs  : 'msg_only_first_franchisee_can_create_subscription',
  NoFirstFranchiseeFound: 'msg_no_first_franchisee_found',
  OfficeIsBlocked: 'msg_login_office_is_blocked',
});

export type ValidationStatus = EnumSet<typeof ValidationStatus>;
